import React from 'react'

import { useMemo, memo, useCallback, useState, useRef, useEffect } from 'react'

import CheckboxEl from '../Managed/CheckboxEl'

import arePropsEqual from '@function/arePropsEqual'

import { isTrue } from '@root/utility'

import FormsStore from '@Store/Forms'

export default memo(function Checkbox ({ name, ...props })
{
	const [show_error, setShowError] = useState();

	const FORM_NAME = useMemo(function ()
	{
		return props.form || 'no-form';
	},
	[props.form]);

	const errors_version_ref = useRef();

	const state_value = FormsStore.useState(s => s[FORM_NAME]?.[name]);
	const _submit_id  = FormsStore.useState(s => s[FORM_NAME]?._submit_id);

	const default_value = props['default-value'] !== undefined
	? isTrue(props['default-value'])
	: undefined;

	useEffect(function ()
	{
	// réaffiche les erreurs au moment de submit le formulaire,
	// pour gérer le cas où le champ a été modifié (donc l'erreur masquée)
	// mais la validation retourne la même erreur qu'avant modification
		if (_submit_id && _submit_id !== errors_version_ref.current)
		{
			setShowError(true);

			errors_version_ref.current = _submit_id;

			return;
		}

		setShowError(function (show_error)
		{
			return !props.error & show_error === undefined && !_submit_id
			? show_error
			: !props.error && !show_error
			? show_error
			: props.error && show_error
			? show_error
			: props.error ? true : false;
		});
	},
	[props.error, _submit_id]);

	useEffect(() =>
	{
		if (state_value !== undefined) return;

	// pullstate initialisé ou reset, on l'update avec la valeur par défaut

		FormsStore.update(function (state)
		{
			state[FORM_NAME] = state[FORM_NAME] || { };

			state[FORM_NAME][name] = default_value !== undefined
			? default_value
			: false;
		});
	},
	[state_value, default_value, FORM_NAME, name]);

	const toggle = useCallback(function ()
	{
		FormsStore.update(function (state)
		{
			state[FORM_NAME] = state[FORM_NAME] || { };

			state[FORM_NAME][name] = !isTrue(state[FORM_NAME][name]);
		});

		if (show_error) setShowError(false);
	},
	[FORM_NAME, name, show_error]);

	return (
		<CheckboxEl { ...props } checked={ isTrue(state_value) }
			onChange={ toggle } show_error={ show_error }
		/>
	);
},
arePropsEqual);